import React from 'react';
import { Comment, Segment, Header, Icon } from 'semantic-ui-react';
import ChatMessage from "./ChatMessage";

const ChatHistory = ({ messages }) => {
  // If no messages, show empty state
  if (!messages || messages.length === 0) {
    return (
      <Segment placeholder textAlign="center" basic>
        <Header icon>
          <Icon name="conversation" />
          No messages yet
        </Header>
        <p>
          Once you've loaded a patient, you can start asking questions about their medical records.
        </p>
      </Segment>
    );
  }
  
  return (
    <Comment.Group className="chat-history">
      {messages.map((message) => (
        <ChatMessage key={message.id} message={message} />
      ))}
    </Comment.Group>
  );
};

export default ChatHistory;